import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app_state';

@Component({
  selector: 'yi-side',
  template: require('./side.component.html'),
  styles: [require('./side.component.scss')]
})
export class SideComponent implements OnInit {

  isLastStep = false;
  lastStepName = '';

  constructor(private store: Store<IAppState>,
              private translateService: TranslateService) {
    this.store.select(state => state.app.install.navigation).subscribe(
      items => {
        let currentStep = items.navigationItems.filter(item => item.active === true)[0];
        this.isLastStep = currentStep.isLastStep;
        this.lastStepName = (this.translateService.instant(currentStep.name) + '-last-step').toLowerCase();
      });
  }

  ngOnInit() {
  }

}
